module.exports = __webpack_public_path__ + "17820e32f88fe386b31286d02e62c41f.png";